import actions from './actions';
import initialState from '../initialState';

export const appraiserReducer = (state = initialState.appraisers, action) => {
    switch (action.type) {
        case actions.SET_APPRAISER_MODAL:
            return { ...state, appraiserModal: action.state.appraiserModal };
        case actions.SET_DELETE_APPRAISER_MODAL:
            return {
                ...state,
                deleteAppraiserModal: action.state.deleteAppraiserModal,
            };
        case actions.SET_RESTORE_APPRAISER_MODAL:
            return {
                ...state,
                restoreAppraiserModal: action.state.restoreAppraiserModal,
            };
        default:
            return { ...state };
    }
};

export default appraiserReducer;
